import * as React from 'react';

import { trackFiltersClick, trackSortClick } from './tracking';
import { Filters16, Sort16, Sucess16 } from '@cian/ui-kit/icons';
import { mergeStyles } from '@cian/utils';

import { EOrderField } from '../../repositories/favorites/v1/web-get-user-favorites';

import * as styles from './TopBar.css';
import { ClickOutside } from '../ClickOutside';

export interface ITopBarStoreProps {
  total: React.ReactNode | null;
  orderField?: EOrderField | null;
  checkbox: React.ReactNode | null;
  massActions: React.ReactNode | null;
  filtersVisible: boolean;
  getFavoriteEntities(orderType: EOrderField): void;
  setShowFiltersModal(howFiltersModal: boolean): void;
  setOrderField(orderType: EOrderField): void;
}

export type TTopBarProps = ITopBarStoreProps;

const SORT_TYPE_BUTTONS = [
  { name: 'По дате добавления в избранное', type: EOrderField.Added },
  { name: 'По цене', type: EOrderField.Price },
];

export const TopBar: React.FC<ITopBarStoreProps> = ({
  total,
  orderField,
  checkbox,
  massActions,
  getFavoriteEntities,
  setShowFiltersModal,
  setOrderField,
  filtersVisible,
}) => {
  const [showSortMenu, setShowSortMenu] = React.useState<boolean>(false);

  const closeShowSortMenu = () => {
    setShowSortMenu(false);
  };

  const openShowSortMenu = () => {
    setShowSortMenu(true);
  };

  const handleFilterClick = () => {
    setShowFiltersModal(true);
    trackFiltersClick();
  };

  const handleSortClick = (order: EOrderField) => {
    setOrderField(order);
    getFavoriteEntities(order);
    trackSortClick(order);
    closeShowSortMenu();
  };

  const getDefaultName = () => SORT_TYPE_BUTTONS.find(button => button.type === orderField)?.name;

  return (
    <div className={styles['container']}>
      <div className={styles['total']}>
        {checkbox && <div className={styles['checkbox']}>{checkbox}</div>}
        {total && <span className={styles['total-count']}>{total}</span>}
        <ClickOutside onOutside={closeShowSortMenu}>
          <button onClick={openShowSortMenu} className={styles['input-link']}>
            <Sort16 color="primary_100" /> {getDefaultName()}
          </button>
          {showSortMenu && (
            <div className={styles['sort-container']}>
              <ul className={styles['sort-list']}>
                {SORT_TYPE_BUTTONS.map(button => (
                  <li
                    key={button.type}
                    {...mergeStyles(
                      styles['sort-list-item'],
                      button.type === orderField && styles['sort-list-item--active'],
                    )}
                    onClick={() => handleSortClick(button.type)}
                  >
                    {button.name}
                    {button.type === orderField && <Sucess16 color="primary_100" />}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </ClickOutside>
        {filtersVisible && (
          <button onClick={handleFilterClick} className={styles['input-link']}>
            <Filters16 color="primary_100" /> Фильтр
          </button>
        )}
      </div>
      {massActions && <div className={styles['buttons']}>{massActions}</div>}
    </div>
  );
};
